export function computePeriodRange(period) {
  const now = new Date();
  const end = new Date(); // aujourd'hui
  const start = new Date();

  switch (period) {
    case 'day':
      start.setDate(now.getDate() - 1);
      break;
    case 'week':
      start.setDate(now.getDate() - 7);
      break;
    case 'month':
      start.setMonth(now.getMonth() - 1);
      break;
    case 'year':
      start.setFullYear(now.getFullYear() - 1);
      break;
    default:
      start.setDate(now.getDate() - 7); // fallback: 1 semaine
  }

  const format = (d) => d.toISOString().split('T')[0]; // "YYYY-MM-DD"

  return {
    start: format(start),
    end: format(end),
  };
}
